import SidebarTemplate from 'components/templates/SidebarTemplate';
import React from 'react';
import StampHistoryLayout from 'components/organismos/master/atendanceManagement/StampHistoryLayout';

const StampHistoryPage = () => (
  <SidebarTemplate>
    <StampHistoryLayout />
  </SidebarTemplate>
);

export default StampHistoryPage;
